import { Credentials } from './../models/login-models';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UserDivisions } from '@app/@core/constants/user-credentials.constants';
import { LOCALSTORAGE_HASCERTIFIEDPAYMENT } from '../constants/users.constants';

const credentialsKey = 'credentials';

/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  private _credentials: Credentials | null = null;
  private userLoggedIn = new Subject<boolean>();

  constructor() {
    const savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    const credentials: Credentials = JSON.parse(localStorage.getItem('credentials'));

    if (credentials && credentials.acceptance === true) {
      this.userLoggedIn.next(true);
      return !!this.credentials;
    }
    this.userLoggedIn.next(false);
    return false;
  }

  isDivisionAutos(): boolean {
    const credentials: Credentials = JSON.parse(localStorage.getItem('credentials'));

    //console.log('credentials: ', credentials);
    if (credentials && credentials.division == UserDivisions.AUTOS) {
      return true;
    } else {
      return false;
    }
  }

  isDivisionConsumption(): boolean {
    const credentials: Credentials = JSON.parse(localStorage.getItem('credentials'));

    console.log('credentials: ', credentials);
    if (credentials && credentials.division === UserDivisions.CONSUMPTION) {
      return true;
    } else {
      return false;
    }
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    return this._credentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;

    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.clear();
      //TODO: check if it is necessary
      //this.cookieService.delete('JWT_ACCESS_COOKIE');
    }
  }
}
